/* [BD feat] Cart remove confirmation modal — Intercepts remove, shows modal with product image */

class BdCartRemoveModal extends HTMLElement {
  constructor() {
    super();
    this._pendingRemove = null;
    this._boundHandleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    const drawer = this.closest('cart-drawer');
    if (!drawer) return;
    drawer.addEventListener('click', this._boundHandleClick, true);
    this.querySelector('.bd-remove-modal__overlay')?.addEventListener('click', () => this.close());
    this.querySelector('.bd-remove-modal__keep')?.addEventListener('click', () => this.close());
    this.querySelector('.bd-remove-modal__remove')?.addEventListener('click', () => this.confirmRemove());
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.close();
    });
  }

  disconnectedCallback() {
    const drawer = this.closest('cart-drawer');
    if (drawer) drawer.removeEventListener('click', this._boundHandleClick, true);
  }

  handleClick(e) {
    const removeBtn = e.target.closest('cart-remove-button');
    if (!removeBtn || !removeBtn.closest('.bd-cart-drawer')) return;
    const btn = removeBtn.querySelector('button');
    if (btn?.classList.contains('hidden')) return;
    e.preventDefault();
    e.stopPropagation();
    const cartItem = removeBtn.closest('.cart-item');
    if (!cartItem) return;
    const img = cartItem.querySelector('.cart-item__image');
    const nameEl = cartItem.querySelector('.cart-item__name');
    const index = removeBtn.dataset.index;
    const cartItems = removeBtn.closest('cart-drawer-items');
    if (!cartItems || !index) return;
    this._pendingRemove = { removeBtn, cartItems, index };
    const imgSrc = (img && img.src) ? img.src : (this.dataset.placeholder || '');
    const bgColor = cartItem.dataset.bgColor || '';
    this.open(imgSrc, nameEl?.textContent?.trim() || '', bgColor);
  }

  open(imgSrc, productTitle, bgColor) {
    const img = this.querySelector('.bd-remove-modal__img');
    const title = this.querySelector('.bd-remove-modal__title');
    if (img) {
      img.src = imgSrc || this.dataset.placeholder || '';
      img.alt = productTitle || '';
      img.style.display = '';
      img.style.backgroundColor = (bgColor && bgColor.trim()) ? bgColor.trim() : '';
    }
    if (title) title.textContent = productTitle || '';
    this.setAttribute('open', '');
    this.querySelector('.bd-remove-modal__keep')?.focus();
  }

  close() {
    this.removeAttribute('open');
    this._pendingRemove = null;
  }

  confirmRemove() {
    if (!this._pendingRemove) return;
    const { removeBtn, cartItems, index } = this._pendingRemove;
    this.close();
    const event = { currentTarget: removeBtn };
    cartItems.updateQuantity(index, 0, event);
    this._pendingRemove = null;
  }
}

customElements.define('bd-cart-remove-modal', BdCartRemoveModal);
